var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRouble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8925 18.3191V19.971H19.9304V21.8042H15.8925V24H13.5793V21.8042H11.7734V19.971H13.5793V18.3191H11.7734V16.5262H13.5793V9.99915H18.4492C19.5314 9.99915 20.4445 10.1872 21.1885 10.5632C21.946 10.9258 22.5074 11.4227 22.8727 12.0539C23.2514 12.6852 23.4408 13.3902 23.4408 14.1692C23.4408 14.881 23.2717 15.5525 22.9335 16.1837C22.5953 16.8149 22.0542 17.332 21.3102 17.7349C20.5662 18.1243 19.6126 18.3191 18.4492 18.3191H15.8925ZM15.8925 16.5262H18.4492C19.3285 16.5262 19.9846 16.318 20.4174 15.9017C20.8503 15.4853 21.0667 14.9078 21.0667 14.1692C21.0667 13.4171 20.8503 12.8329 20.4174 12.4166C19.9846 12.0002 19.3285 11.7921 18.4492 11.7921H15.8925V16.5262Z",
    fill: "#141233"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouble);
export default __webpack_public_path__ + "static/media/rouble.901cf554.svg";
export { ForwardRef as ReactComponent };